import { createTheme } from "@mui/material/styles";
export const workareaTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#ffb563" },
    secondary: { main: "#ffca79" },
    background: { default: "#121820", paper: "#1c2530" },
    text: { primary: "#eef3f8", secondary: "#a9b6c5" },
  },
  typography: { fontFamily: "Roboto, Arial, sans-serif", fontSize: 12 },
});

// Persisted workarea preference; absent preference follows the operating system.
export function readWorkareaMode() {
  try {
    const value = localStorage.getItem("betty-workarea-theme");
    if (["light", "dark"].includes(value)) return value;
  } catch {}
  return typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}
export function saveWorkareaMode(mode) {
  try {
    localStorage.setItem("betty-workarea-theme", mode);
  } catch {}
}
export function createWorkareaTheme(mode) {
  return createTheme({
    typography: workareaTheme.typography,
    palette: {
      mode,
      primary: { main: mode === "dark" ? "#70c8ff" : "#0863d8" },
      secondary: { main: mode === "dark" ? "#57dbc8" : "#007f79" },
      background: {
        default: mode === "dark" ? "#14212d" : "#f4f8fc",
        paper: mode === "dark" ? "#213242" : "#fff",
      },
      text: {
        primary: mode === "dark" ? "#edf5ff" : "#172b49",
        secondary: mode === "dark" ? "#bfccdb" : "#4a617d",
      },
    },
  });
}
